import { APP_ROUTES } from "@/constants/routes";
import { Category } from "@/models/category";
import { MenuItem, MenuList, Popover } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { StarIcon } from "lucide-react";
import Link from "next/link";

interface MenuCategoryProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  handlePopoverClose: () => void;
  cancelCloseTimer?: () => void;
  startCloseTimer?: () => void;
  locale?: string;
}

const MenuCategory = ({
  anchorEl,
  handlePopoverClose,
  open,
  cancelCloseTimer,
  startCloseTimer,
  locale,
}: MenuCategoryProps) => {
  const queryClient = useQueryClient();
  const categories =
    queryClient.getQueryData<Category[]>([
      "categories-wp",
      {
        language: locale,
      },
    ]) || [];
  return (
    <Popover
      id="mouse-over-popover"
      sx={{ pointerEvents: "auto", marginTop: "10px" }}
      open={open}
      anchorEl={anchorEl}
      disableScrollLock
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      onClose={handlePopoverClose}
      disableRestoreFocus
      slotProps={{
        paper: {
          sx: {
            padding: "10px",
            pointerEvents: "auto",
          },
          onMouseEnter: () => {
            if (typeof cancelCloseTimer === "function") cancelCloseTimer();
          },
          onMouseLeave: () => {
            if (typeof startCloseTimer === "function") startCloseTimer();
          },
        },
      }}
    >
      <MenuList
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1,
          "& .MuiMenuItem-root": {
            minWidth: "auto",
            padding: "12px 16px",
            borderRadius: "8px",
            backgroundColor: "#fff",
            transition: "all 0.2s ease",
            "&:hover": {
              backgroundColor: "#E0E7FF !important",
              transform: "translateY(-2px)",
            },
          },
        }}
      >
        {categories.map((category) => {
          const slugLang =
            category.languages.find((lang) => lang.language === locale)?.slug ||
            category.slug ||
            "";
          return (
            <MenuItem
              key={category?.id}
              component={Link}
              href={APP_ROUTES(locale as any).RESOURCES.to(slugLang)}
              onClick={handlePopoverClose}
              className="text-cimigoBlue font-semibold hover:!bg-ciBlue_100 flex gap-2 items-center justify-start"
            >
              <StarIcon size={20} />
              <span className="truncate">{category?.name}</span>
            </MenuItem>
          );
        })}
      </MenuList>
    </Popover>
  );
};

export default MenuCategory;
